import React from "react"
import Hero from "../../components/Careers/SkillFactory/Hero"
import LayoutDark from "../../components/LayoutDark"
import SEO from "../../components/Seo"

const SkillFactory = () => {
  return (
    <LayoutDark>
      <SEO title="Skill Factory" />
      <Hero />
    </LayoutDark>
  )
}

export default SkillFactory
